import React from "react";
import { FlyerDetailPagePreviewSubcategoriesListProps } from "./flyer-detail-page-preview-subcategories-list.props";
import { HostContainer } from "./flyer-detail-page-preview-subcategories-list.styles";
import { makeKey } from "../../../../../../../../../../utils/helpers";

export const FlyerDetailPagePreviewSubcategoriesList = (
  props: FlyerDetailPagePreviewSubcategoriesListProps
) => (
  <HostContainer>
    {props.categories.map((category, index) => (
      <div key={makeKey("category", index)}>{category.name}</div>
    ))}
  </HostContainer>
);
